var map = {
	"./template.bet575": 1086,
	"./template.bet575.tsx": 1086,
	"./template.bet777": 1087,
	"./template.bet777.tsx": 1087,
	"./template.betgalaxy": 1088,
	"./template.betgalaxy.tsx": 1088,
	"./template.betprofessor": 2116,
	"./template.betprofessor.tsx": 2116,
	"./template.betroyale": 2117,
	"./template.betroyale.tsx": 2117,
	"./template.betstride": 1089,
	"./template.betstride.tsx": 1089,
	"./template.buffalobet": 2118,
	"./template.buffalobet.tsx": 2118,
	"./template.chromabet": 1090,
	"./template.chromabet.tsx": 1090,
	"./template.default": 658,
	"./template.default.tsx": 658,
	"./template.epicodds": 2119,
	"./template.epicodds.tsx": 2119,
	"./template.fiestabet": 2120,
	"./template.fiestabet.tsx": 2120,
	"./template.forsport": 1091,
	"./template.forsport.tsx": 1091,
	"./template.gigabet": 2121,
	"./template.gigabet.tsx": 2121,
	"./template.goldenbet888": 2016,
	"./template.goldenbet888.tsx": 2016,
	"./template.goldenrush": 2122,
	"./template.goldenrush.tsx": 2122,
	"./template.hyperbet": 1092,
	"./template.hyperbet.tsx": 1092,
	"./template.juicybet": 2123,
	"./template.juicybet.tsx": 2123,
	"./template.junglebet": 2124,
	"./template.junglebet.tsx": 2124,
	"./template.magnumbet": 1093,
	"./template.magnumbet.tsx": 1093,
	"./template.oldgill": 1094,
	"./template.oldgill.tsx": 1094,
	"./template.puntcity": 1095,
	"./template.puntcity.tsx": 1095,
	"./template.puntgenie": 1096,
	"./template.puntgenie.tsx": 1096,
	"./template.pyramidbet": 1097,
	"./template.pyramidbet.tsx": 1097,
	"./template.questbet": 1098,
	"./template.questbet.tsx": 1098,
	"./template.slambet": 2125,
	"./template.slambet.tsx": 2125,
	"./template.sterlingparker": 2126,
	"./template.sterlingparker.tsx": 2126,
	"./template.sugarcastle": 1099,
	"./template.sugarcastle.tsx": 1099,
	"./template.templebet": 2127,
	"./template.templebet.tsx": 2127,
	"./template.titanbet": 2128,
	"./template.titanbet.tsx": 2128,
	"./template.ts": 88,
	"./template.vikingbet": 1100,
	"./template.vikingbet.tsx": 1100,
	"./template.volcanobet": 1101,
	"./template.volcanobet.tsx": 1101,
	"./template.wellbet": 2129,
	"./template.wellbet.tsx": 2129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2425;